import {
  createListSearch,
  type ListSearch,
  type ResolvedListSearch,
} from '@/lib/list/list-search';

/**
 * The URL contract for the prototype list (spec R6.6).
 *
 * The same three controls as the project list, so the same codec: sort keys are
 * the API's own `field:direction` strings, defaults are omitted from the URL,
 * and parsing is total. What differs is only which sorts the endpoint accepts —
 * `PROTOTYPE_SORTABLE_FIELDS` on the server — so that is all this file states.
 */

export const PROTOTYPE_SORTS = ['updatedAt:desc', 'name:asc'] as const;

export type PrototypeSort = (typeof PROTOTYPE_SORTS)[number];

/** Most recently uploaded to first — what a reviewer opening a project wants. */
export const DEFAULT_PROTOTYPE_SORT: PrototypeSort = 'updatedAt:desc';

/** Labels for the sort control, in the order they are offered. */
export const PROTOTYPE_SORT_OPTIONS: ReadonlyArray<{
  value: PrototypeSort;
  label: string;
}> = [
  { value: 'updatedAt:desc', label: 'Recently updated' },
  { value: 'name:asc', label: 'Name (A–Z)' },
];

/** Cards per page (spec R6.6), matching the project grid. */
export const PROTOTYPES_PAGE_SIZE = 24;

export const prototypesSearchCodec = createListSearch<PrototypeSort>({
  sorts: PROTOTYPE_SORTS,
  defaultSort: DEFAULT_PROTOTYPE_SORT,
  pageSize: PROTOTYPES_PAGE_SIZE,
});

export type PrototypesSearch = ListSearch<PrototypeSort>;
export type ResolvedPrototypesSearch = ResolvedListSearch<PrototypeSort>;

/** The project detail route's `validateSearch`: total, defaulting, never throwing. */
export const validatePrototypesSearch = (
  raw: Record<string, unknown>,
): PrototypesSearch => prototypesSearchCodec.parse(raw);
